import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Baby } from "lucide-react";

export default function GuardianStep({ guardian, setGuardian, family }) {
  const minors = family.filter((m) => Number(m.age) < 18 && m.age !== "");
  const set = (k) => (e) =>
    setGuardian({ ...(guardian || {}), [k]: e.target.value });

  return (
    <div data-testid="step-guardian">
      <h2 className="font-serif text-2xl text-navy">Guardian for Minor Children</h2>
      <p className="mt-2 text-sm text-[#4A5568] sm:text-base">
        Because you have minor {minors.length === 1 ? "child" : "children"}, Indian law requires
        you to nominate a guardian. If both parents pass on, the guardian takes care of the
        minors until they turn 18.
      </p>

      {minors.length > 0 && (
        <div className="mt-5 rounded-md border border-gold/40 bg-[#FBF7EE] p-4" data-testid="guardian-minor-summary">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
            Minors detected
          </div>
          <ul className="mt-2 space-y-1 text-sm text-navy">
            {minors.map((m) => (
              <li key={m.id} className="flex items-center gap-2">
                <Baby size={14} className="text-gold" />
                {m.name} — {m.relationship}, age {m.age}
              </li>
            ))}
          </ul>
        </div>
      )}

      <Card className="mt-5 border-[#0A1128]/10">
        <CardContent className="p-6 sm:p-8">
          <div className="font-serif text-lg text-navy">Primary Guardian</div>
          <div className="mt-4 grid gap-4 sm:grid-cols-2">
            <div className="sm:col-span-2">
              <Label htmlFor="guardian-name">Full name *</Label>
              <Input
                id="guardian-name"
                className="mt-2"
                value={guardian?.name || ""}
                onChange={set("name")}
                placeholder="e.g. Sunita Patel"
                data-testid="guardian-name"
              />
            </div>
            <div>
              <Label htmlFor="guardian-rel">Relationship *</Label>
              <Input
                id="guardian-rel"
                className="mt-2"
                value={guardian?.relationship || ""}
                onChange={set("relationship")}
                placeholder="Aunt / Uncle / Grandparent"
                data-testid="guardian-rel"
              />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="mt-4 border-[#0A1128]/10">
        <CardContent className="p-6 sm:p-8">
          <div className="flex items-center justify-between">
            <div className="font-serif text-lg text-navy">Backup Guardian</div>
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#4A5568]">Recommended</span>
          </div>
          <div className="mt-4 grid gap-4 sm:grid-cols-2">
            <div className="sm:col-span-2">
              <Label htmlFor="guardian-backup-name">Full name</Label>
              <Input
                id="guardian-backup-name"
                className="mt-2"
                value={guardian?.backup_name || ""}
                onChange={set("backup_name")}
                placeholder="Optional"
                data-testid="guardian-backup-name"
              />
            </div>
            <div>
              <Label htmlFor="guardian-backup-rel">Relationship</Label>
              <Input
                id="guardian-backup-rel"
                className="mt-2"
                value={guardian?.backup_relationship || ""}
                onChange={set("backup_relationship")}
                placeholder="Aunt / Uncle / Grandparent"
                data-testid="guardian-backup-rel"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
